module.exports = __webpack_public_path__ + "static/media/error.6e417924.png";